import { Rotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/entities/Rotationsplan';
import { KalenderArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderArbeitsbereich';
import { filterRotationsplaene } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/filterRotationsplaene';
import { filterRotationsplaeneByArbeitsbereiche } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/filterRotationsplaeneByArbeitsbereiche';
import {
  sortRotationsplaene,
  sortRotationsplaeneByArbeitsbereich,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/sortRotationsplaene';
import { RotationsplanFeatureProps } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/types';

export function applyDefaultFilterAndSortingForRotationsplaene(
  rotationsplaene: Rotationsplan[],
  defaultStore: RotationsplanFeatureProps,
) {
  const filteredRotationsplaene = filterRotationsplaene(
    'standorte',
    defaultStore.ui.kalender.filter.standorte,
    defaultStore.ui.kalender.filter,
    rotationsplaene,
  );

  return sortRotationsplaene(
    filteredRotationsplaene,
    defaultStore.ui.kalender.istSortierungAufsteigend,
  );
}

export function applyDefaultFilterAndSortingForRotationsplaeneByArbeitsbereiche(
  rotationsplaene: KalenderArbeitsbereich[],
  defaultStore: RotationsplanFeatureProps,
) {
  const filteredRotationsplaene = filterRotationsplaeneByArbeitsbereiche(
    'standorte',
    defaultStore.ui.kalender.filter.standorte,
    defaultStore.ui.kalender.filter,
    rotationsplaene,
  );
  return sortRotationsplaeneByArbeitsbereich(
    filteredRotationsplaene,
    defaultStore.ui.kalender.istSortierungAufsteigend,
  );
}
